import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AuthLayout from '@/layouts/Auth/AuthLayout.vue'
import OnBoardingLayout from '@/layouts/Onboarding/OnBoardingLayout.vue'
import { parseToken } from '@/utils/Utils'
import StudentOnboarding from '@/layouts/StudentOnboarding/StudentOnboarding.vue'
import MentorLayout from '@/layouts/Mentor/MentorLayout.vue'
import StudentLayout from '@/layouts/Student/StudentLayout.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      redirect: '/auth/login',
      children: []
    },
    {
      path: '/auth',
      component: AuthLayout,
      redirect: '/auth/login',
      children: [
        {
          path: 'login',
          name: 'auth.login',
          component: () => import('@/views/auth/Login.vue')
        },
        {
          path: 'forgot-password',
          name: 'auth.forgotPw',
          component: () => import('@/views/auth/ForgotPassword/ForgotPassword.vue')
        }
      ],
      meta: {
        isAuth: false
      }
    },
    {
      path: '/mentor/onboarding',
      component: OnBoardingLayout,
      redirect: '/mentor/onboarding/step-1',
      meta: {
        isAuth: true
      },
      children: [
        {
          path: 'step-1',
          name: 'mentor.onboarding.step1',
          component: () => import('@/views/mentor/Onboarding/step1/Step1.vue')
        },
        {
          path: 'step-2',
          name: 'mentor.onboarding.step2',
          component: () => import('@/views/mentor/Onboarding/step2/Step2.vue')
        },
        {
          path: 'step-3',
          name: 'mentor.onboarding.step3',
          component: () => import('@/views/mentor/Onboarding/step3/Step3.vue')
        },
        {
          path: 'step-4',
          name: 'mentor.onboarding.step4',
          component: () => import('@/views/mentor/Onboarding/step4/Step4.vue')
        },
        {
          path: 'step-5',
          name: 'mentor.onboarding.step5',
          component: () => import('@/views/mentor/Onboarding/step5/Step5.vue')
        },
        {
          path: 'step-6',
          name: 'mentor.onboarding.step6',
          component: () => import('@/views/mentor/Onboarding/step6/Step6.vue')
        }
      ]
    },
    {
      path: '/mentor/app',
      name: 'mentor.app',
      component: MentorLayout,
      redirect: '/mentor/app/dashboard',
      meta: {
        isAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'mentor.app.dashboard',
          component: () => import('@/views/mentor/app/Dashboard.vue')
        },
        {
          path: 'students',
          name: 'mentor.app.students',
          component: () => import('@/layouts/Mentor/student/MentorStudentLayout.vue'),
          redirect: '/mentor/app/students/list',
          children: [
            {
              path: 'list',
              name: 'mentor.app.students.list',
              component: () => import('@/views/mentor/app/Students/Students.vue')
            },
            {
              path: 'table/:id',
              name: 'mentor.app.students.table',
              component: () => import('@/views/mentor/app/Students/StudentTableScreen.vue')
            }
          ]
        },
        {
          path: 'profile',
          name: 'mentor.app.profile',
          component: () => import('@/views/mentor/app/Profile/Profile.vue')
        },
        {
          path: 'appointments',
          name: 'mentor.app.appointments',
          component: () => import('@/views/mentor/app/Appointments/Appointments.vue')
        },
        {
          path: 'sinavlar',
          name: 'sinav',
          component: () => import('@/views/sinav/sinavlarList.vue')
        }
      ]
    },
    {
      name: 'student.app',
      path: '/student/app',
      component: StudentLayout,
      redirect: '/student/app/dashboard',
      meta: {
        isAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'student.app.dashboard',
          component: () => import('@/views/student/app/Dashboard.vue')
        }
      ]
    },
    {
      path: '/student/onboarding',
      component: StudentOnboarding,
      redirect: '/student/onboarding/step-1',
      meta: {
        isAuth: true
      },
      children: [
        {
          path: 'step-1',
          name: 'student.onboarding.step1',
          component: () => import('@/views/student/Onboarding/Step1.vue')
        }
      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/mobile-detect',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/MobileDetect.vue')
    }
  ]
})
router.beforeEach(async (to, _, next) => {
  const isHaveToken = parseToken()
  const userType = localStorage.getItem('userType')
  const onBoardingStatus = localStorage.getItem('userStatus')
  const isOnBoarding = onBoardingStatus === 'OnboardProgress'

  if (to.meta.isGlobal) {
    return next()
  }

  if (to.meta.isAuth && !isHaveToken) {
    return next('/auth/login')
  }
  if (isOnBoarding && isHaveToken && !to.path.startsWith('/mentor/onboarding')) {
    return next('/mentor/onboarding')
  }
  if (!isOnBoarding && isHaveToken && to.path.startsWith('/mentor/onboarding')) {
    return next('/mentor/app/dashboard')
  }

  if (!to.meta.isAuth && isHaveToken) {
    if (to.path.startsWith('/mentor/app')) {
      return next()
    } else {
      return next('/mentor/app/dashboard')
    }
  }

  if (userType === 'Coach' && !to.path.startsWith('/mentor') && isHaveToken) {
    return next('/mentor/app/dashboard')
  }

  next()
})

export default router
